import { MockedProvider } from "@apollo/client/testing/react";
import React, { useEffect } from "react";
import { FIND_MISSION_AUDIT_LOGS } from "../../graphql/core";
import type { Meta, StoryObj } from "@storybook/react";
import { currentLang } from "../../atoms/i18n";
import MissionLogsScreen from "../../screens/user/MissionLogs";
import { defaultApolloClientCache } from "../../configs/graphql.config";
import { buildAuditLogPageResult } from "../factories";
import { AtomsHydrator } from "../../atoms/atoms-hydrator";

const mocks = [
    {
        maxUsageCount: Number.POSITIVE_INFINITY,
        request: {
            query: FIND_MISSION_AUDIT_LOGS,
            variables: () => true,
        },
        error: undefined,
        result: (variables: { offset: number }) => {
            const offset = variables.offset;
            return {
                data: {
                    findMissionAuditLogs: buildAuditLogPageResult(100, offset),
                },
            };
        },
    },
];

function StoryComponent() {
    const missionId = `test-mission-id`;

    useEffect(() => {}, []);

    return (
        <AtomsHydrator atomValues={[[currentLang, "fr"]]}>
            <MockedProvider mocks={mocks} cache={defaultApolloClientCache}>
                {/* @ts-expect-error Stack Component need a complex navigation handler */}
                <MissionLogsScreen route={{ params: { missionId } }} />
            </MockedProvider>
        </AtomsHydrator>
    );
}

const meta = {
    title: "Screens/MissionLogs",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
